import { IEnrolmentStatus } from '../../../types';

export type IEnrolmentStatusState = IEnrolmentStatus;

export enum EnrolmentStatusActionTypes {
  UPDATE_ARRIVAL_STATUS = '@@student/enrolmentStatus/UPDATE_ARRIVAL_STATUS',
}
